// extracted by mini-css-extract-plugin
export default {"changeMultipleProducts":"change-multiple-products_changeMultipleProducts__PjwPB","table":"change-multiple-products_table__H-ztb"};